import { Navbar, Container, Nav } from "react-bootstrap";

const NavigationBar = () => {
  return (
    <Navbar variant="dark" className="fixed-top navbar-dark shadow-sm" bg="dark">
      <Container>
        <Navbar.Brand>Sidiq Film</Navbar.Brand>
        <Nav>
          <Nav.Link href="#trending">Trending</Nav.Link>
          <Nav.Link href="#superhero">Superhero</Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
